import React from 'react';
import { Card, Badge, ProgressBar } from 'react-bootstrap';

export default function SongCard({ song }) {
  if (!song || !song.is_playing) {
    return (
      <Card bg="dark" text="white" className="border-secondary">
        <Card.Body className="d-flex align-items-center gap-3">
          <div
            className="bg-secondary rounded"
            style={{ width: 56, height: 56, flexShrink: 0 }}
          />
          <div>
            <div className="text-muted">Kein Song läuft gerade</div>
          </div>
        </Card.Body>
      </Card>
    );
  }

  const progress = song.duration_ms > 0
    ? Math.round((song.progress_ms / song.duration_ms) * 100)
    : 0;

  const fmt = (ms) => {
    const s = Math.floor(ms / 1000);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
  };

  return (
    <Card bg="dark" text="white" className="border-success">
      <Card.Body>
        <div className="d-flex align-items-center gap-3 mb-2">
          {song.cover_url && (
            <img
              src={song.cover_url}
              alt="Album Cover"
              style={{ width: 56, height: 56, borderRadius: 6, objectFit: 'cover' }}
            />
          )}
          <div className="overflow-hidden">
            <div className="fw-semibold text-truncate">{song.title}</div>
            <div className="text-success text-truncate">{song.artist}</div>
            {song.album && (
              <div className="text-muted small text-truncate">{song.album}</div>
            )}
          </div>
          <Badge bg="success" className="ms-auto">▶ Live</Badge>
        </div>
        <ProgressBar
          now={progress}
          variant="success"
          style={{ height: 4 }}
          className="mb-1"
        />
        <div className="d-flex justify-content-between text-muted small">
          <span>{fmt(song.progress_ms)}</span>
          <span>{fmt(song.duration_ms)}</span>
        </div>
      </Card.Body>
    </Card>
  );
}
